import { Box, Button, Container, Typography } from "@mui/material";

import CallIcon from "@mui/icons-material/Call";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import aboutHeroBg from "../../assets/images/about_h_2.png";
import aboutHeroBg_m from "../../assets/images/about_h_m.png";

export default function AboutHero() {
  return (
    <Box
      sx={{
        position: "relative",

        overflow: "hidden",

        minHeight: {
          xs: "75vh",
          md: "80vh",
        },

        display: "flex",

        alignItems: "center",

        backgroundImage: {
          xs: `url(${aboutHeroBg_m})`,
          md: `url(${aboutHeroBg})`,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",

        backgroundRepeat: "no-repeat",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            maxWidth: "850px",

            textAlign: {
              xs: "center",
              lg: "left",
            },
          }}
        >
          {/* BADGE */}

          <Box
            sx={{
              display: "inline-flex",

              alignItems: "center",

              px: 2.5,

              py: 1,

              borderRadius: "50px",

              background: "rgba(255,255,255,.75)",

              border: "1px solid rgba(255,255,255,.9)",

              backdropFilter: "blur(12px)",

              color: "#0057FF",

              fontWeight: 700,

              fontSize: "12px",

              letterSpacing: "1px",

              textTransform: "uppercase",
            }}
          >
            About Comet Cleaners
          </Box>

          {/* HEADING */}

          <Typography
            sx={{
              mt: {
                xs: 2,
                md: 3,
              },
              display: "block",
              fontWeight: 900,

              color: "#07122F",

              lineHeight: {
                xs: 1.08,
                md: 1.05,
              },

              letterSpacing: "-1px",

              fontSize: {
                xs: "32px",
                sm: "32px",
                md: "56px",
                lg: "56px",
              },
            }}
          >
            One Stop Care
            <br />
            <Box
              component="span"
              sx={{
                background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                WebkitBackgroundClip: "text",

                WebkitTextFillColor: "transparent",
              }}
            >
              With Attention To
              <br />
              Every Detail
            </Box>
          </Typography>

          {/* DESCRIPTION */}

          <Typography
            sx={{
              mt: {
                xs: 2,
                md: 3,
              },

              //   maxWidth: {
              //     xs: "100%",
              //     md: "700px",
              //   },

              mx: {
                xs: "auto",
                lg: 0,
              },

              color: "#64748B",

              lineHeight: 1.9,

              fontSize: {
                xs: "13px",
                sm: "14px",
                md: "16px",
              },
            }}
          >
            We deliver professional cleaning, repairs, custom printing and
            specialty care services across Ajax and surrounding communities with
            expert craftsmanship, convenience and a commitment to exceptional
            service.
          </Typography>

          {/* BUTTONS */}

          <Box
            sx={{
              mt: {
                xs: 4,
                md: 5,
              },

              display: "flex",

              justifyContent: {
                xs: "center",
                lg: "flex-start",
              },

              gap: {
                xs: 1.5,
                md: 2,
              },

              flexWrap: "nowrap",
            }}
          >
            <Button
              startIcon={<WhatsAppIcon />}
              href="https://wa.me/+19054283542"
              target="_blank"
              sx={{
                flex: 1,

                maxWidth: {
                  xs: "190px",
                  md: "250px",
                },

                height: {
                  xs: "54px",
                  md: "62px",
                },

                borderRadius: "60px",

                color: "#fff",

                fontWeight: 800,

                fontSize: {
                  xs: "14px",
                  md: "16px",
                },

                background: "linear-gradient(135deg,#25D366,#1EBE5D)",

                boxShadow: "0 15px 35px rgba(37,211,102,.28)",

                transition: ".35s",

                "&:hover": {
                  transform: "translateY(-4px)",

                  boxShadow: "0 22px 45px rgba(37,211,102,.35)",

                  background: "linear-gradient(135deg,#25D366,#1EBE5D)",
                },
              }}
            >
              WhatsApp Us
            </Button>
            <Button
              startIcon={<CallIcon />}
              href="tel:+19054283542"
              sx={{
                flex: 1,

                maxWidth: {
                  xs: "170px",
                  md: "220px",
                },

                height: {
                  xs: "54px",
                  md: "62px",
                },

                borderRadius: "60px",

                color: "#0057FF",

                fontWeight: 800,

                fontSize: {
                  xs: "14px",
                  md: "16px",
                },

                background: "rgba(255,255,255,.82)",

                border: "1px solid rgba(255,255,255,.9)",

                backdropFilter: "blur(20px)",

                boxShadow: "0 12px 30px rgba(0,87,255,.10)",

                transition: ".35s",

                "&:hover": {
                  transform: "translateY(-4px)",

                  background: "#ffffff",

                  boxShadow: "0 20px 40px rgba(0,87,255,.16)",
                },
              }}
            >
              Call Now
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
